















import { Vue, Component } from 'vue-property-decorator'
import AuthLayout from '@/admin/layouts/AuthLayout.vue'
import FormBase from '@/shared/classes/form/form-base'
import Field from '@/shared/classes/form/field'
import { FieldTypes } from '@/shared/components/form/field-types'
import { Positions } from '@/shared/interfaces/classes/form.interfaces'
import tokenHelper from '@/shared/helpers/token.helper'
import { AuthActions } from '@/shared/store/auth/auth.actions'
import { AdminRoutes } from '@/shared/router/admin'
import Form from '@/shared/components/form/Form.vue'
import __ from '@/shared/helpers/__'

@Component({
  components: {
    AuthLayout,
    Form
  },
  methods: {
    __
  }
})
export default class Login extends Vue {
  form: FormBase = new FormBase()
    .setEndpoint('login')
    .setAutocompleteEnabled()
    .setFields([
      (new Field())
        .setType(FieldTypes.email)
        .setKey('email')
        .setTitle(__('admin.views.login.form.email')),
      (new Field())
        .setType(FieldTypes.password)
        .setKey('password')
        .setTitle(__('admin.views.login.form.password')),
    ])
    .setOnSuccess(this.onSuccess)
    .setSubmit({
      text: __('admin.views.login.form.submit'),
      position: Positions.center
    })

  async onSuccess(response: any) {
    tokenHelper.setToken(response.access_token)
    await this.$store.dispatch(AuthActions.me)
      .then(() => this.$router.push({ name: AdminRoutes.index }))
  }

  goToRemindPassword(): void {
    this.$router.push({ name: AdminRoutes.remindPassword })
  }
}
